export const TrustedByCompanies = () => {
  return (
    <div className="container-lg flex justify-center">
      <div className="">
        <div className="mb-20 text-center text-16-26 text-gray-600">
          Trusted by innovators like you
        </div>
        <div className="mt-8 flex flex-wrap items-center justify-center gap-28 md:flex-nowrap ">
          <a
            href="https://lighton.ai"
            target="_blank"
            rel="noreferrer"
            className="shrink-0"
          >
            <img
              src="/assets/customers/lighton.jpg"
              alt="Lighton"
              className="h-36 pt-6 opacity-80 grayscale hover:opacity-100 hover:grayscale-0"
            />
          </a>
          <a
            href="https://www.cursor.so"
            target="_blank"
            rel="noreferrer"
            className="hidden shrink-0 sm:block"
          >
            <img
              src="/assets/customers/cursor.svg"
              alt="Cursor"
              className="h-28 opacity-90 brightness-50 grayscale hover:opacity-100"
            />
          </a>

          <a
            href="https://mem.ai"
            target="_blank"
            rel="noreferrer"
            className="shrink-0"
          >
            <img
              src="/assets/customers/memai.svg"
              alt="Mem.ai"
              className="mr-4 h-[28px] pt-2 opacity-80 grayscale hover:opacity-100 hover:grayscale-0"
            />
          </a>
          <a
            href="https://athenago.com"
            target="_blank"
            rel="noreferrer"
            className="shrink-0"
          >
            <img
              src="/assets/customers/athena-black.png"
              alt="Athena"
              className="h-[19px] opacity-60 grayscale hover:opacity-100 hover:grayscale-0"
            />
          </a>

          <a
            href="https://retainit.app/"
            target="_blank"
            rel="noreferrer"
            className="shrink-0"
          >
            <img
              src="/assets/customers/retainit.svg"
              alt="Retainit"
              className=" h-[16px] opacity-80 grayscale hover:opacity-100 hover:grayscale-0"
            />
          </a>

          {/* <a
            href="https://www.tantl.com/"
            target="_blank"
            rel="noreferrer"
            className="hidden shrink-0 sm:block "
          >
            <img
              src="/assets/customers/tantl.svg"
              alt="Tantl"
              className="-mx-4  h-24 opacity-80 grayscale hover:opacity-100 hover:grayscale-0"
            />
          </a> */}
          {/* <a
            href="https://www.peppertype.ai/"
            target="_blank"
            rel="noreferrer"
            className="hidden shrink-0 sm:block "
          >
            <img
              src="/assets/customers/peppertype.svg"
              alt="Peppertype.ai"
              className="opacity-80 grayscale hover:opacity-100 hover:grayscale-0"
            />
          </a> */}
        </div>
      </div>
    </div>
  );
};
